import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7809932c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-content" }
const _hoisted_2 = { class: "work-space" }
const _hoisted_3 = { class: "space-title" }
const _hoisted_4 = {
  class: "add-time",
  id: "addTimeId"
}
const _hoisted_5 = {
  key: 0,
  class: "date_box"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  class: "sliders-list",
  id: "sliderListId"
}
const _hoisted_8 = { class: "sliders" }
const _hoisted_9 = ["onClick", "data-index"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "start",
  id: "startId"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "end-box",
  id: "endBoxId"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "end",
    id: "endId"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "end-radio",
    id: "endRadioId"
  })
], -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "add-time-btn" }
const _hoisted_15 = {
  key: 0,
  class: "device-title"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "预约开启设备", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1))
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "work-device" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "空调", -1))
const _hoisted_22 = { class: "device-box" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "row-item" }
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "照明", -1))
const _hoisted_27 = { class: "device-box" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "row-item" }
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 2,
  class: "device-tip"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计费方式:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, " * "),
  /*#__PURE__*/_createTextVNode(" 空调延时采用后付费方式，系统将根据您申请的时间产生延时费用。预约时间下您可自由开启空间下的设备。 ")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 收费标准按开机设备对应空间的面积计费，空调加时费用按50元/m2·h进行计费，照明设备延时使用不计费。 ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 如您提前结束工作，请点击“我要离开”按钮，系统会自动调整设备关闭时间，感谢与您一同共创可持续的办公环境。 ", -1))
const _hoisted_36 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.spaceInfo.spaceName) + " 申请延时", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.dateArr && _ctx.dateArr.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateArr, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["date-item", item.isActive ? 'date-item-active' : '']),
                onClick: _withModifiers(($event: any) => (_ctx.checkDate(item, index)), ["stop"]),
                key: 'date' + index
              }, [
                _createElementVNode("span", null, _toDisplayString(item.week), 1),
                _createElementVNode("span", null, _toDisplayString(item.day), 1)
              ], 10, _hoisted_6))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nowTimerArr, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'slider' + index,
            class: "sliders-wrapper",
            id: "slidersWrapperId"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("div", { class: "label" }, _toDisplayString(item.timer), 513), [
                [_vShow, index === 0 || index % 2 === 0]
              ]),
              _createElementVNode("div", {
                class: "slider-box",
                onClick: ($event: any) => (_ctx.checkSlider(item, index)),
                "data-index": index
              }, null, 8, _hoisted_9)
            ])
          ]))
        }), 128)),
        (_ctx.approvalData && _ctx.approvalData.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.approvalData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "approval-status",
                key: 'approval' + index,
                onClick: ($event: any) => (_ctx.checkApprovalStatus(item, $event)),
                style: _normalizeStyle({
              left: item.left + 'px',
              background: item.bg,
            })
              }, _toDisplayString(item.text), 13, _hoisted_10))
            }), 128))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "slider-btn",
          id: "sliderBtnId",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerDelTime && _ctx.triggerDelTime(...args)))
        }, _hoisted_13)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", {
        class: "cancel-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeWorkTimer && _ctx.closeWorkTimer(...args)))
      }, "取消"),
      _createElementVNode("div", {
        class: _normalizeClass(["comfirm-btn", _ctx.formBtn ? 'comfirm-btn-diabled' : '']),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addWorkTimer && _ctx.addWorkTimer(...args)))
      }, " 提交申请 ", 2)
    ]),
    (_ctx.isLight || _ctx.isAir)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_19))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      (_ctx.isAir)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nowData.equipmentList, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: 'eq' + index
                }, [
                  (item.equipmentCategory !== 'SELTLT')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "device-row",
                        style: _normalizeStyle({ width: _ctx.airNum == 1 ? '98%' : '48%' }),
                        onClick: ($event: any) => (_ctx.checkEquipment(item))
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", null, _toDisplayString(item.localName), 1),
                          _createElementVNode("img", {
                            src: 
                    item.isCheck
                      ? _ctx.parseImgUrl('ipdImages', 'check-open.svg')
                      : _ctx.parseImgUrl('ipdImages', 'check-close.svg')
                  ,
                            alt: ""
                          }, null, 8, _hoisted_25)
                        ])
                      ], 12, _hoisted_23))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isLight)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nowData.equipmentList, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: 'eq' + index
                }, [
                  (item.equipmentCategory === 'SELTLT')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "device-row",
                        style: _normalizeStyle({ width: _ctx.lightNum == 1 ? '98%' : '48%' }),
                        onClick: ($event: any) => (_ctx.checkEquipment(item))
                      }, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", null, _toDisplayString(item.localName), 1),
                          _createElementVNode("img", {
                            src: 
                    item.isCheck
                      ? _ctx.parseImgUrl('ipdImages', 'check-open.svg')
                      : _ctx.parseImgUrl('ipdImages', 'check-close.svg')
                  ,
                            alt: ""
                          }, null, 8, _hoisted_30)
                        ])
                      ], 12, _hoisted_28))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isLight || _ctx.isAir)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_36))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_van_loading, {
          key: 1,
          class: "temp-loading"
        }))
      : _createCommentVNode("", true)
  ]))
}